// extracted by mini-css-extract-plugin
export default {"container":"ProductSidebars-container-Z5L","mobile":"ProductSidebars-mobile-qUV","item":"ProductSidebars-item-eYx"};